import { OutliersPnlStrategy } from 'widgets/outliers/data/pnlStrategies/index';
import isNil from 'lodash/isNil';

export const unrealisedPnlStrategy: OutliersPnlStrategy = {
    mapOrder: (order, benchmarkPrice, exchangeRate: number) => {
        const { lpD, rem } = order;

        if (isNil(lpD) || isNil(benchmarkPrice)) {
            return undefined;
        }

        const lp = lpD * exchangeRate;

        const pAndL = (rem ?? 0) * (lp - benchmarkPrice);
        const benchmarkPerformance =
            ((lp - benchmarkPrice) / benchmarkPrice) * 10000;
        return { benchmarkPerformance, pnl: pAndL };
    },
    requiredColumns: ['lpD', 'rem'],
};
